import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownsOpenFactory {
  constructor() { }

  dropdownOpen: any = null;
  dropdownsOpen: any = [];

  addDropdown(dropdown:any) {
    this.dropdownOpen = dropdown;
    this.dropdownsOpen.push(dropdown);
  }

  closeDropdown() {
    this.dropdownsOpen.forEach((dropdownOpen: any) => {
      if(dropdownOpen?.overlayVisible || dropdownOpen?.visible){
        dropdownOpen.hide();
      }
    });
    // if(this.dropdownOpen?.overlayVisible || this.dropdownOpen?.visible){
    //   this.dropdownOpen.hide();
    // }
    this.dropdownOpen = null;
    this.dropdownsOpen = [];
  }

  closeLastDropdown(){
    // let lastDropdown: any = this.dropdownsOpen[this.dropdownsOpen.length-1];
    // lastDropdown.hide();
    // this.dropdownsOpen.splice(this.dropdownsOpen.length-1, 1);
    // this.dropdownOpen = this.dropdownsOpen[this.dropdownsOpen.length-1];
    for(let i = this.dropdownsOpen.length-1; i >= 0; i--){
      if(this.dropdownsOpen[i] === this.dropdownOpen){
        this.dropdownsOpen[i].hide();
        this.dropdownsOpen.splice(i, 1);
        this.dropdownOpen = this.dropdownsOpen[this.dropdownsOpen.length-1];
        break;
      }
    }
  }

  getDropdown(){
    return this.dropdownOpen;
  }
}
